module.exports = __webpack_public_path__ + "04e794d8616679d3c8bfbe370b9d1f3a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./blog/releasing-reindex-graphql-backend-as-a-service/illustration-nobg.png
 ** module id = 348
 ** module chunks = 0
 **/